var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "team leave") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 4.70967742,
    y: 3.75572519,
    width: 137.522581,
    height: 114.549618
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-3",
    cx: 23.0774194,
    cy: 17.370229,
    rx: 5.18064516,
    ry: 5.16412214
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-4",
    cx: 56.9870968,
    cy: 17.370229,
    rx: 5.18064516,
    ry: 5.16412214
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-5",
    cx: 90.8967742,
    cy: 17.370229,
    rx: 5.18064516,
    ry: 5.16412214
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-6",
    cx: 125.748387,
    cy: 17.370229,
    rx: 5.18064516,
    ry: 5.16412214
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.973064,13.3631529 C12.7104377,13.9581969 11.2794613,14.321835 9.72222222,14.321835 C8.16498316,14.321835 6.69191919,13.9581969 5.47138047,13.3631529 C2.31481481,13.9912549 0,16.2061411 0,18.8507812 L0,22.3355556 L19.4444444,22.3355556 L19.4444444,18.8507812 C19.4444444,16.1730831 17.0875421,13.9912549 13.973064,13.3631529 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53525641,12.0268376 C12.8545399,12.0268376 15.5181624,9.30844281 15.5181624,6.0134188 C15.5181624,2.7183948 12.8135611,0 9.53525641,0 C6.25695176,0 3.55235043,2.7595826 3.55235043,6.0546066 C3.55235043,9.34963061 6.21597295,12.0268376 9.53525641,12.0268376 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.973064,13.3631529 C12.7104377,13.9581969 11.2794613,14.321835 9.72222222,14.321835 C8.16498316,14.321835 6.69191919,13.9581969 5.47138047,13.3631529 C2.31481481,13.9912549 0,16.2061411 0,18.8507812 L0,22.3355556 L19.4444444,22.3355556 L19.4444444,18.8507812 C19.4444444,16.1730831 17.0875421,13.9912549 13.973064,13.3631529 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53525641,12.0268376 C12.8545399,12.0268376 15.5181624,9.30844281 15.5181624,6.0134188 C15.5181624,2.7183948 12.8135611,0 9.53525641,0 C6.25695176,0 3.55235043,2.7595826 3.55235043,6.0546066 C3.55235043,9.34963061 6.21597295,12.0268376 9.53525641,12.0268376 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5281385,15.5555556 C15.034632,16.2482245 13.3419913,16.6715221 11.5,16.6715221 C9.65800866,16.6715221 7.91558442,16.2482245 6.47186147,15.5555556 C2.73809524,16.2867061 0,18.8649737 0,21.9435022 L0,26 L23,26 L23,21.9435022 C23,18.8264921 20.2121212,16.2867061 16.5281385,15.5555556 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2788462,14 C15.2050843,14 18.3557692,10.8356164 18.3557692,7 C18.3557692,3.16438356 15.1566122,0 11.2788462,0 C7.40108008,0 4.20192308,3.21232877 4.20192308,7.04794521 C4.20192308,10.8835616 7.35260801,14 11.2788462,14 Z",
    id: "path-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "team-leave"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-msg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(85.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-60",
    fill: "#87D5FA",
    x: 0,
    y: 0,
    width: 146,
    height: 123
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-61"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 5.20967742,
    y: 4.25572519,
    width: 136.522581,
    height: 113.549618
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-61-Copy",
    fill: "#EB8181",
    x: 5.6516129,
    y: 4.69465649,
    width: 135.63871,
    height: 24.4122137
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-23"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#64808C",
    strokeWidth: 0.80471916,
    cx: 23.0774194,
    cy: 17.370229,
    rx: 4.77828558,
    ry: 4.76176256
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-23-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#64808C",
    strokeWidth: 0.80471916,
    cx: 56.9870968,
    cy: 17.370229,
    rx: 4.77828558,
    ry: 4.76176256
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-23-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#64808C",
    strokeWidth: 0.80471916,
    cx: 90.8967742,
    cy: 17.370229,
    rx: 4.77828558,
    ry: 4.76176256
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-23-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#64808C",
    strokeWidth: 0.80471916,
    cx: 125.748387,
    cy: 17.370229,
    rx: 4.77828558,
    ry: 4.76176256
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.0774194,0.469465649 L23.0774194,13.6145038",
    id: "Line-38",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9870968,0.469465649 L56.9870968,13.6145038",
    id: "Line-38-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.748387,0.469465649 L125.748387,13.6145038",
    id: "Line-38-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8967742,0.469465649 L90.8967742,13.6145038",
    id: "Line-38-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-62",
    stroke: "#64808C",
    x: 14.6290323,
    y: 51.2022901,
    width: 67.7612903,
    height: 45.9465649
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0709677,74.6450382 L81.9483871,74.6450382",
    id: "Line-39",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4064516,52.110687 L66.4064516,97.188777",
    id: "Line-40",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5096774,52.110687 L48.5096774,97.188777",
    id: "Line-40-Copy",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-64",
    fill: "#EB8181",
    x: 30.1419355,
    y: 75.1145038,
    width: 17.8967742,
    height: 21.5954198
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    points: "33.4387097 87.5083357 37.0492942 90.6344859 45.683871 82.0184104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6129032,52.110687 L30.6129032,97.188777",
    id: "Line-40-Copy-2",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-63",
    fill: "#87D5FA",
    x: 86.6580645,
    y: 50.7022901,
    width: 46.1548387,
    height: 46.9465649
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(89.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy",
    transform: "translate(21.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M14.0320402,13.8866419 C12.6831446,14.4968596 11.231233,14.821835 9.72222222,14.821835 C8.20096843,14.821835 6.70714452,14.4903804 5.40865179,13.8870268 C2.50660746,14.5222556 0.5,16.5486917 0.5,18.8507812 L0.5,21.8355556 L18.9444444,21.8355556 L18.9444444,18.8507812 C18.9444444,16.5423633 16.9294573,14.5273116 14.0320402,13.8866419 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M9.53525641,11.5268376 C12.5631823,11.5268376 15.0181624,9.04764284 15.0181624,6.0134188 C15.0181624,2.9939694 12.5368477,0.5 9.53525641,0.5 C6.54238694,0.5 4.05235043,3.02634642 4.05235043,6.0546066 C4.05235043,9.07986997 6.49849495,11.5268376 9.53525641,11.5268376 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy-2",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M14.0320402,13.8866419 C12.6831446,14.4968596 11.231233,14.821835 9.72222222,14.821835 C8.20096843,14.821835 6.70714452,14.4903804 5.40865179,13.8870268 C2.50660746,14.5222556 0.5,16.5486917 0.5,18.8507812 L0.5,21.8355556 L18.9444444,21.8355556 L18.9444444,18.8507812 C18.9444444,16.5423633 16.9294573,14.5273116 14.0320402,13.8866419 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M9.53525641,11.5268376 C12.5631823,11.5268376 15.0181624,9.04764284 15.0181624,6.0134188 C15.0181624,2.9939694 12.5368477,0.5 9.53525641,0.5 C6.54238694,0.5 4.05235043,3.02634642 4.05235043,6.0546066 C4.05235043,9.07986997 6.49849495,11.5268376 9.53525641,11.5268376 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M16.5870128,16.0782253 C14.9954353,16.7915834 13.2816158,17.1715221 11.5,17.1715221 C9.7033471,17.1715221 7.93928671,16.783764 6.4092076,16.0786038 C2.92002491,16.8184403 0.5,19.2149948 0.5,21.9435022 L0.5,25.5 L22.5,25.5 L22.5,21.9435022 C22.5,19.2075405 20.0701214,16.8246638 16.5870128,16.0782253 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M11.2788462,13.5 C14.9129427,13.5 17.8557692,10.5753653 17.8557692,7 C17.8557692,3.44175655 14.8816857,0.5 11.2788462,0.5 C7.68611051,0.5 4.70192308,3.47959732 4.70192308,7.04794521 C4.70192308,10.6130341 7.63451238,13.5 11.2788462,13.5 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamLeave);
export default __webpack_public_path__ + "static/media/teamLeave.0ae16f3774995ceb0f92753e6c781689.svg";
export { ForwardRef as ReactComponent };